import { useContext } from 'react';
import { ConfigContext } from './context';
import type { ConfigContextValue } from './types';

export const useConfig = (): ConfigContextValue => {
  const ctx = useContext(ConfigContext);
  if (!ctx) throw new Error('useConfig must be used within ConfigProvider');
  return ctx;
};
